import { sendGeneralRequest } from '../../../../features/generalRequest'

const determineInvoiceListRequest = (utilityName, token, state, extraInvoiceListData = {}) => 
{
    switch(utilityName)
    {
        case 'GJOBAT':
            return sendGeneralRequest({request: {token: token, serie: state.Serial}, baseUrlKey:'services', endpoint: 'Penalty/GetTicket'})
        case 'QEZHEF':
            return sendGeneralRequest({request: {token: token, serie: state.Serial}, baseUrlKey:'services', endpoint: 'QEZHEF/GetInvoice'})
        case 'DIGICOM':
            return sendGeneralRequest({request: {token: token, invoiceID: state.Serial}, baseUrlKey:'services', endpoint: 'DIGICOM/GetInvoiceForInvoiceID'})
        case 'ALBTELECOM':
            return sendGeneralRequest({request: {token: token, serie: state.Serial}, baseUrlKey:'services', endpoint: 'ALBTELECOM/GetInvoiceAlbtelecom'})
        case 'OSHEE':
            return sendGeneralRequest({request: {token: token, serie: state.Serial, type: extraInvoiceListData.type}, baseUrlKey:'services', endpoint: 'OSHEE/GetBill'})
        case 'FirstCom':
            return sendGeneralRequest({request: {token: token, id: state.Id}, baseUrlKey:'services', endpoint: 'Firstcom/GetClientFirstComById'})
        case utilityName.startsWith('UK') ? utilityName : '' : 
            return sendGeneralRequest({request: {token: token, serie: state.Serial, contractNo: extraInvoiceListData.contractNumber, service: utilityName}, baseUrlKey:'services', endpoint: 'UK/GetInvoiceUK'})

    }
}

export {determineInvoiceListRequest as determineInvoiceListRequest}